import { get, post } from './api';

export const getCartList = function() {
    return get('/order/cartList');
};

export const addToCart = function(id, amount) {
    return post('/order/addToCart', { id, amount });
};

export const batchDeleteCart = function(ids) {
    return post('/order/batchDeleteCart', { ids });
};

export const clearCart = function() {
    return post('/order/clearCart');
};

export const getWayBillMoney = function(orderAmount) {
    return get('/config/getWayBillMoney', { orderAmount });
};

export const createOrder = function(params) {
    return post('/order/createOrder', params);
};

export const getOrder = function(params) {
    return get('/order/myOrderList', params);
};

export const getOrderDetail = function(params) {
    return get('/order/myOrderDetailList', params);
};

export const getWayBill = function(params) {
    return get('/order/findWayBillPage', params);
};

export const getWayBillDetail = function(params) {
    return get('/order/wayBillDetailList', params);
};
